import { useState } from "react";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";

import { MAX_PRO_DATE_RANGE } from "@/constants/config";
import { MAX_MEGA_FLIGHT_RANGE } from "@/constants/membership";
import usePlatform from "@/hooks/usePlatform";
import ProChip from "@/components/ProChip";

interface SearchSwitchProps {
  value: boolean;
  showUpsell: boolean;
  onChange: (val: boolean) => void;
}

const SearchSwitch = (props: SearchSwitchProps) => {
  const [visible, setVisible] = useState(false);
  const [freePlan, setFreePlan] = useState(false);
  const { isPc } = usePlatform();
  return (
    <div className="flex items-center">
      <FormControlLabel
        className="!mr-[0px]"
        control={
          <Switch
            onChange={(e) => {
              //

              props.onChange(e.target.checked);
              if (e.target.checked && props.showUpsell) {
                setFreePlan(true);
              }
            }}
            checked
            // checked={props.value}
          />
        }
        sx={{ color: (theme) => theme.palette.text.secondary }}
        label={
          <span className="flex items-center">
            <Typography>{MAX_MEGA_FLIGHT_RANGE + "-entry search"}</Typography>
            <ProChip />
          </span>
        }
      />
      {/* <Tooltip
        sx={{ size: 10 }}
        title="These suggestions are based on the cheapest fares to popular destinations in the next twelve months. Prices are for one-way flights for one adult."
      > */}
      <InfoOutlinedIcon
        sx={{ fontSize: 16, marginLeft: "4px", color: (theme) => theme.palette.text.secondary }}
        onClick={() => {
          setVisible(true);
        }}
      />
      {/* </Tooltip> */}
      <Dialog
        open={visible}
        onClose={() => setVisible(false)}
        PaperProps={{
          sx: {
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent>
          <Typography color="primary" fontSize={18} fontWeight={600}>
            PRO feature
          </Typography>
          <Typography fontSize={16}>
            One origin, one arrival, one way, and one day is one entry.
            <Typography fontSize={16}>
              {"With " +
                MAX_MEGA_FLIGHT_RANGE +
                "-entry search, you're able to search one airline route for "}
              <Typography color="primary" className="inline" fontSize={16}>
                {MAX_MEGA_FLIGHT_RANGE + " days"}
              </Typography>
            </Typography>
            <Typography fontSize={16}>
              {"Or you can search 1 departure airport to 2 arrival airports for " +
                Math.floor(MAX_MEGA_FLIGHT_RANGE / 2) +
                " days, and so on. You have the full control of how you want to leverage this powerful feature."}
            </Typography>
          </Typography>
          {/* {props.showUpsell && (
            <Typography color="primary" fontSize={16}>
              Free user can use this feature to search over {MAX_PRO_DATE_RANGE}-day period.
            </Typography>
          )}
          <Typography color="primary" fontSize={16}>
            PRO user enjoys this powerful feature to search over the whole year of data.
          </Typography> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setVisible(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={freePlan}
        onClose={() => setVisible(false)}
        PaperProps={{
          sx: {
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent>
          <Typography color="primary" fontSize={18} fontWeight={600}>
            PRO feature
          </Typography>
          <Typography fontSize={16}>
            One origin, one arrival, one way, and one day is one entry.
            <Typography fontSize={16}>
              {"With " +
                MAX_MEGA_FLIGHT_RANGE +
                "-entry search, you're able to search one airline route for "}
              <Typography color="primary" className="inline" fontSize={16}>
                {MAX_MEGA_FLIGHT_RANGE + " days"}
              </Typography>
            </Typography>
            <Typography fontSize={16}>
              {"Or you can search 1 departure airport to 2 arrival airports for " +
                Math.floor(MAX_MEGA_FLIGHT_RANGE - 1 / 2) +
                " days, and so on. You have the full control of how you want to leverage this powerful feature."}
            </Typography>
          </Typography>
          {/* <Typography color="primary" fontSize={16}>
            Free user can only search over {MAX_PRO_DATE_RANGE}-day period.
          </Typography>
          <Typography color="primary" fontSize={16}>
            PRO user can enjoy searching over the 365 days.
          </Typography> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFreePlan(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SearchSwitch;
